import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setMessage } from "./message";
import EventBus from "../../utils/EventBus";
import QUOTEAPI from "../../Api/quote";

// Create Quote
export const createQuote = createAsyncThunk('quote/createB2bLead', async (formData, thunkAPI) => {
    try {
        const response = await QUOTEAPI.createQuote(formData);
        const message=(response.data.message)

        thunkAPI.dispatch(setMessage(message))
        return response.data;
    }catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message)
    }
})

// Get Quote
export const getQuote = createAsyncThunk('quote/getQuote', async (params, thunkAPI) => {
  try {
      const response = await QUOTEAPI.getQuote(params);
      const message=(response.message)

      thunkAPI.dispatch(setMessage(message))
      return response.data;
  }catch (error) {
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        EventBus.dispatch("logout");
      }
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue(message)
  }
})


// Get Quote
export const getQuoteByServiceId = createAsyncThunk('quote/getQuoteByServiceId ', async ({params, q_id}, thunkAPI) => {
    try {
        const response = await QUOTEAPI.getQuoteByServiceId(params, q_id);
        const message=(response.message)

        thunkAPI.dispatch(setMessage(message))
        return response.data;
    }catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message)
    }
})

// Get Quote By Id
export const getQuoteById = createAsyncThunk('quote/getQuoteById', async ({q_id}, thunkAPI) => {
    try {
        const response = await QUOTEAPI.getQuoteById(q_id);
        const message=(response.message)

        thunkAPI.dispatch(setMessage(message))
        return response.data;
    }catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message)
    }
})

// Update Quote 
export const updateQuote = createAsyncThunk('quote/updateQuote', async ({q_id, formData}, thunkAPI) => {
    try {
        const response = await QUOTEAPI.updateQuote(q_id, formData);

        const message=(response.data.message)
        // console.log("message:",response)
        thunkAPI.dispatch(setMessage(message))
        return response.data;
    }catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          EventBus.dispatch("logout");
        }
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue(message)
    }
})

const quoteSlice = createSlice({
    name: 'quote',
    initialState: {
        quotes : [],
        quoteService:[],
        quoteDetails : {},
        totalPages: "",
        totalCount: 0
    },
     extraReducers: (builder) => { 
        builder
          .addCase(getQuote.fulfilled, (state, action) => {
            state.quotes = action.payload.data
            state.totalPages = action.payload.totalPages
            state.totalCount = action.payload.totalCount
          })
          .addCase(getQuoteByServiceId.fulfilled, (state, action) => {
            state.quoteService = action.payload.data
            state.totalPages = action.payload.totalPages
            state.totalCount = action.payload.totalCount
          })
          .addCase(createQuote.fulfilled, (state, action) => {
            state.quotes.push(action.payload.data)
          })
          .addCase(updateQuote.fulfilled, (state, action) => {
                  const {arg: { c_id }} = action.meta;
                  if (c_id) {
                    state.quotes = state.quotes.map((item) =>
                      item._id === c_id ? action.payload.data : item
                    );
                  };
            })
          .addCase(getQuoteById.fulfilled, (state, action) => {
            state.quoteDetails = action.payload.data;
          })
        }
});

const { reducer } = quoteSlice;
export default reducer;